import { StudioPermissions } from '@/enums/VersioningStatus';

export const getDisabledDirectLessons = (
  studioPermissions: StudioPermissions,
) => {
  return (
    !studioPermissions.allowOtherSteps.simpleEditing &&
    !studioPermissions.allowOtherSteps.advancedEditing
  );
};
